<template>
  <vx-card title="Tax Reference">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getTaxReferenceLookup"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].taxReferenceId">
                      {{ data[indextr].taxReferenceId }}
                    </vs-td>
                    <vs-td :data="data[indextr].taxReferenceCode">
                      {{ data[indextr].taxReferenceCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].taxReferenceName">
                      {{ data[indextr].taxReferenceName }}
                    </vs-td>
                    <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].earningsTypeId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(data[indextr].earningsTypeId)
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  data() {
    return {
      taxReference: {
        taxReferenceId: 0,
        taxReferenceCode: "",
        taxReferenceName: "",
      },
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllTaxReferenceLookup").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getTaxReferenceLookup() {
      return this.$store.state.lookup.getAllTaxReferenceLookup;
    },
  },
};
</script>
